import FooterComponent from "../footer/footer";

export default function MainLayout({children}) {
    return (
        <div className="">
            {children}
            <FooterComponent />
        </div>
    )
}